import { Component } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-common",
  template: ` <p>common works!</p> `,
  styles: [],
})
export class CommonComponent {
  languague: string;
  constructor(private _snackBar: MatSnackBar, private translateService: TranslateService,) {
    this.languague = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
    this.translateService.use(this.languague);
  }

  isInvalidFirstChar(input) {
    const notValidFirstC = new RegExp(/^[@*=+-]/g);
    let isInValid = false;

    switch (typeof input) {
      case "object": {
        if (input.time_zone) {
          input.time_zone = "";
        }

        isInValid = Object.values(input).some((val) => {
          if (typeof val !== 'object') {
            return notValidFirstC.test(<string>val)
          } else {
            return false;
          }
        });
        break;
      }

      case "string": {
        isInValid = !notValidFirstC.test(<string>input);
        break;
      }
    }

    if (isInValid) {
      this.openSnackBar(
        this.translateService.instant("Characters starting with +,-,@,= and * are not allowed."),
        ""
      )
    }

    return isInValid;
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

}